import React from "react"

import PropTypes from "prop-types"
import {Transition} from "semantic-ui-react"

import Alert from "../Alert/alert"

import "./notifications.scss"

const Notifications = ({displayNotifications, notifications = [], onDismiss = () => ""}) => {
    const hasNotifications = displayNotifications && notifications.length > 0

    return (
        <div
            aria-label={hasNotifications ? "Notifications" : undefined}
            className="notifications-component"
            role={hasNotifications ? "region" : undefined}
        >
            <Transition.Group animation="fade down" duration={500}>
                {displayNotifications &&
                    notifications.map(notification => (
                        <Alert
                            className="notification-component"
                            key={"notification-" + notification.id}
                            onDismiss={notification?.noDismiss ? null : () => onDismiss(notification)}
                            {...notification}
                        />
                    ))}
            </Transition.Group>
        </div>
    )
}

Notifications.propTypes = {
    displayNotifications: PropTypes.bool.isRequired,
    notifications: PropTypes.array,
    onDismiss: PropTypes.func,
}

export default Notifications
